import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.16683 5.08329C1.01624 5.08329 0.0834961 4.15055 0.0834961 2.99996C0.0834961 1.84937 1.01624 0.916626 2.16683 0.916626C3.31742 0.916626 4.25016 1.84937 4.25016 2.99996C4.25016 4.15055 3.31742 5.08329 2.16683 5.08329ZM8.00016 5.08329C6.84957 5.08329 5.91683 4.15055 5.91683 2.99996C5.91683 1.84937 6.84957 0.916626 8.00016 0.916626C9.15076 0.916626 10.0835 1.84937 10.0835 2.99996C10.0835 4.15055 9.15076 5.08329 8.00016 5.08329ZM13.8335 5.08329C12.6829 5.08329 11.7502 4.15055 11.7502 2.99996C11.7502 1.84937 12.6829 0.916626 13.8335 0.916626C14.9841 0.916626 15.9168 1.84937 15.9168 2.99996C15.9168 4.15055 14.9841 5.08329 13.8335 5.08329Z"
      fill={fill}
    />
    <mask
      id="mask0_2010_46651"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="6"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.16683 5.08329C1.01624 5.08329 0.0834961 4.15055 0.0834961 2.99996C0.0834961 1.84937 1.01624 0.916626 2.16683 0.916626C3.31742 0.916626 4.25016 1.84937 4.25016 2.99996C4.25016 4.15055 3.31742 5.08329 2.16683 5.08329ZM8.00016 5.08329C6.84957 5.08329 5.91683 4.15055 5.91683 2.99996C5.91683 1.84937 6.84957 0.916626 8.00016 0.916626C9.15076 0.916626 10.0835 1.84937 10.0835 2.99996C10.0835 4.15055 9.15076 5.08329 8.00016 5.08329ZM13.8335 5.08329C12.6829 5.08329 11.7502 4.15055 11.7502 2.99996C11.7502 1.84937 12.6829 0.916626 13.8335 0.916626C14.9841 0.916626 15.9168 1.84937 15.9168 2.99996C15.9168 4.15055 14.9841 5.08329 13.8335 5.08329Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_2010_46651)">
      <rect
        x="-25.333"
        y="-30.3334"
        width="66.6667"
        height="66.6667"
        fill={fill}
      />
    </g>
  </g>
);

export default Icon;
